import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./Invoice.css";

const DayBookPrint = () => {
  const [dayBookData, setDayBookData] = useState(null);
  const { date } = useParams();

  // Using the same dummy data from DayBook component
  const sampleTransactions = [
    {
      id: 1,
      date: "2025-11-21",
      type: "sale",
      documentNo: "INV-001",
      party: "SSS Enterprises",
      description: "Pin Box - (00:4) - 73 pcs",
      debit: 0,
      credit: 15505.20,
      balance: 15505.20
    },
    {
      id: 2,
      date: "2025-11-21",
      type: "purchase",
      documentNo: "PUR-001",
      party: "Global Suppliers",
      description: "Raw Materials",
      debit: 12000.00,
      credit: 0,
      balance: 3505.20
    },
    {
      id: 3,
      date: "2025-11-21",
      type: "receipt",
      documentNo: "RCP-001",
      party: "SSS Enterprises",
      description: "Payment Received",
      debit: 10000.00,
      credit: 0,
      balance: -6494.80
    },
    {
      id: 4,
      date: "2025-11-21",
      type: "delivery",
      documentNo: "DN-001",
      party: "SSS Enterprises",
      description: "Goods Delivered",
      debit: 0,
      credit: 0,
      balance: -6494.80
    },
    {
      id: 5,
      date: "2025-11-21",
      type: "expense",
      documentNo: "EXP-001",
      party: "Office Supplies",
      description: "Stationery Purchase",
      debit: 1500.00,
      credit: 0,
      balance: -7994.80
    },
    {
      id: 6,
      date: "2025-11-20",
      type: "sale",
      documentNo: "INV-002",
      party: "John Doe",
      description: "Gum Tape - 50 pcs",
      debit: 0,
      credit: 8850.00,
      balance: 855.20
    },
    {
      id: 7,
      date: "2025-11-20",
      type: "purchase",
      documentNo: "PUR-002",
      party: "ABC Traders",
      description: "Packaging Material",
      debit: 5000.00,
      credit: 0,
      balance: -4144.80
    }
  ];

  useEffect(() => {
    // Filter transactions for the selected date
    const filtered = sampleTransactions.filter(transaction => transaction.date === date);
    
    // Calculate opening balance (from previous day)
    const previousDayTransactions = sampleTransactions.filter(t => t.date < date);
    const openingBalance = previousDayTransactions.length > 0 
      ? previousDayTransactions[previousDayTransactions.length - 1].balance 
      : 0;

    // Calculate totals
    const totals = filtered.reduce((acc, transaction) => {
      return {
        totalDebit: acc.totalDebit + transaction.debit,
        totalCredit: acc.totalCredit + transaction.credit,
        closingBalance: acc.closingBalance + transaction.credit - transaction.debit
      };
    }, { totalDebit: 0, totalCredit: 0, closingBalance: openingBalance });

    setDayBookData({
      date,
      transactions: filtered,
      openingBalance,
      totals
    });

    const waitForContentAndPrint = () => {
      const contentReady = document.readyState === 'complete';
      const hasContent = document.body && document.body.innerText.trim().length > 0;

      if (contentReady && hasContent) {
        if (window.flutter_inappwebview) {
          window.flutter_inappwebview.callHandler('onPrintRequest');
        } else {
          window.print();
        }
      } else {
        setTimeout(waitForContentAndPrint, 200);
      }
    };

    const timer = setTimeout(() => {
      document.title = `DayBook_${date}`;
      waitForContentAndPrint();
    }, 2000);

    return () => clearTimeout(timer);
  }, [date]);

  const getTransactionTypeLabel = (type) => {
    const labels = {
      sale: 'Sale',
      purchase: 'Purchase',
      receipt: 'Receipt',
      payment: 'Payment',
      delivery: 'Delivery',
      expense: 'Expense'
    };
    return labels[type] || type;
  };

  if (!dayBookData) return null;

  return (
    <div className="invoice-container" style={{
      width: "100%",
      maxWidth: "100%",
      margin: "auto",
      padding: "10px",
      fontFamily: "Arial, sans-serif",
      borderRight: "2px solid black",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "center",
      minHeight: "1000px",
      border: "1px solid #000"
    }}>
      {/* Header Section */}
      <div style={{ textAlign: "center", fontSize: "20px", color: "black" }}>
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "black",
        }}>
          <div style={{ flex: 1, textAlign: "left", fontSize: "12px", color: "#000" }}>
            GSTIN No: 33AAAAA0000A1Z5
          </div>
          <div style={{ flex: 1, textAlign: "center", fontSize: "11px", color: "#000" }}>
            திருச்செந்தூர் ஸ்ரீ முருகன் துணை
          </div>
          <div style={{ flex: 1, textAlign: "right", fontSize: "12px" }}>
            Mobile: 9876543210
          </div>
        </div>

        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "10px"
        }}>
          <div>
            <p style={{ color: "#000", fontSize: "30px", margin: "0" }}>
              SRI KUMARAN TRADERS
            </p>
            <span style={{ fontSize: "14px", color: "#000" }}>
              No. 123, Gandhi Road, Sivakasi,<br />
              Tamilnadu-626123,
              <br />Email ID : info@kumarantraders.com
            </span>
          </div>
        </div>
      </div>

      {/* Day Book Title */}
      <div style={{ textAlign: "center", margin: "10px 0" }}>
        <h2 style={{ color: "#000", fontSize: "24px", margin: "0", textDecoration: "underline" }}>
          DAY BOOK
        </h2>
        <p style={{ color: "#000", fontSize: "14px", margin: "5px 0" }}>
          For Date: {new Date(dayBookData.date).toLocaleDateString('en-IN', { 
            weekday: 'long', 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
          })}
        </p>
      </div>

      {/* Summary Section */}
      <table style={{
        width: "100%",
        borderCollapse: "collapse",
        marginTop: "10px",
        fontSize: "11px",
        color: "#000",
        border: "1px solid #000",
      }}>
        <tbody>
          <tr>
            <td style={{
              border: "1px solid #000",
              padding: "3px",
              fontWeight: "bold",
              background: "#f9f9f9",
              textAlign: "center"
            }}>
              Opening Balance
            </td>
            <td style={{
              border: "1px solid #000",
              padding: "3px",
              fontWeight: "bold",
              background: "#f9f9f9",
              textAlign: "center"
            }}>
              Total Debit
            </td>
            <td style={{
              border: "1px solid #000",
              padding: "3px",
              fontWeight: "bold",
              background: "#f9f9f9",
              textAlign: "center"
            }}>
              Total Credit
            </td>
            <td style={{
              border: "1px solid #000",
              padding: "3px",
              fontWeight: "bold",
              background: "#f9f9f9",
              textAlign: "center"
            }}>
              Closing Balance
            </td>
            <td style={{
              border: "1px solid #000",
              padding: "3px",
              fontWeight: "bold",
              background: "#f9f9f9",
              textAlign: "center"
            }}>
              Total Transactions
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid #000", padding: "3px", textAlign: "center", fontWeight: "bold" }}>
              ₹ {Math.abs(dayBookData.openingBalance).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
              {dayBookData.openingBalance >= 0 ? ' Dr' : ' Cr'}
            </td>
            <td style={{ border: "1px solid #000", padding: "3px", textAlign: "center", fontWeight: "bold", color: "#dc3545" }}>
              ₹ {dayBookData.totals.totalDebit.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
            </td>
            <td style={{ border: "1px solid #000", padding: "3px", textAlign: "center", fontWeight: "bold", color: "#28a745" }}>
              ₹ {dayBookData.totals.totalCredit.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
            </td>
            <td style={{ border: "1px solid #000", padding: "3px", textAlign: "center", fontWeight: "bold" }}>
              ₹ {Math.abs(dayBookData.totals.closingBalance).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
              {dayBookData.totals.closingBalance >= 0 ? ' Dr' : ' Cr'}
            </td>
            <td style={{ border: "1px solid #000", padding: "3px", textAlign: "center", fontWeight: "bold" }}>
              {dayBookData.transactions.length}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Transactions Table */}
      <div style={{ display: "flex", flexDirection: "column", minHeight: "68vh" }}>
        <div style={{ flex: 1, overflow: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
            <thead>
              <tr>
                <th style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000" }}>Sno</th>
                <th style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000" }}>Type</th>
                <th style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000" }}>Document No</th>
                <th style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000" }}>Party Name</th>
                <th style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000" }}>Description</th>
                <th style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", textAlign: "right" }}>Debit (₹)</th>
                <th style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", textAlign: "right" }}>Credit (₹)</th>
                <th style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", textAlign: "right" }}>Balance (₹)</th>
              </tr>
            </thead>
            <tbody>
              {/* Opening Balance Row */}
              <tr style={{ backgroundColor: "#fff3cd" }}>
                <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", fontWeight: "bold" }}></td>
                <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", fontWeight: "bold" }}></td>
                <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", fontWeight: "bold" }}></td>
                <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", fontWeight: "bold" }}></td>
                <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", fontWeight: "bold", textAlign: "right" }}>
                  Opening Balance
                </td>
                <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", fontWeight: "bold", textAlign: "right" }}></td>
                <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", fontWeight: "bold", textAlign: "right" }}></td>
                <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", fontWeight: "bold", textAlign: "right" }}>
                  ₹ {Math.abs(dayBookData.openingBalance).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                  {dayBookData.openingBalance >= 0 ? ' Dr' : ' Cr'}
                </td>
              </tr>

              {dayBookData.transactions.map((transaction, index) => (
                <tr key={transaction.id}>
                  <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000" }}>
                    {index + 1}
                  </td>
                  <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000" }}>
                    {getTransactionTypeLabel(transaction.type)}
                  </td>
                  <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000" }}>
                    {transaction.documentNo}
                  </td>
                  <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000" }}>
                    {transaction.party}
                  </td>
                  <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000" }}>
                    {transaction.description}
                  </td>
                  <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#dc3545", textAlign: "right" }}>
                    {transaction.debit > 0 ? `₹ ${transaction.debit.toLocaleString('en-IN', { minimumFractionDigits: 2 })}` : ''}
                  </td>
                  <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#28a745", textAlign: "right" }}>
                    {transaction.credit > 0 ? `₹ ${transaction.credit.toLocaleString('en-IN', { minimumFractionDigits: 2 })}` : ''}
                  </td>
                  <td style={{ 
                    border: "1px solid black", 
                    padding: "1.5px 4px", 
                    fontSize: "11px", 
                    color: transaction.balance >= 0 ? "#28a745" : "#dc3545", 
                    textAlign: "right",
                    fontWeight: "bold"
                  }}>
                    ₹ {Math.abs(transaction.balance).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                    {transaction.balance >= 0 ? ' Dr' : ' Cr'}
                  </td>
                </tr>
              ))}

              {/* Closing Balance Row */}
              <tr style={{ backgroundColor: "#d1ecf1" }}>
                <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", fontWeight: "bold" }}></td>
                <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", fontWeight: "bold" }}></td>
                <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", fontWeight: "bold" }}></td>
                <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", fontWeight: "bold" }}></td>
                <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#000", fontWeight: "bold", textAlign: "right" }}>
                  Closing Balance
                </td>
                <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#dc3545", fontWeight: "bold", textAlign: "right" }}>
                  ₹ {dayBookData.totals.totalDebit.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                </td>
                <td style={{ border: "1px solid black", padding: "1.5px 4px", fontSize: "11px", color: "#28a745", fontWeight: "bold", textAlign: "right" }}>
                  ₹ {dayBookData.totals.totalCredit.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                </td>
                <td style={{ 
                    border: "1px solid black", 
                    padding: "1.5px 4px", 
                    fontSize: "11px", 
                    color: dayBookData.totals.closingBalance >= 0 ? "#28a745" : "#dc3545", 
                    textAlign: "right",
                    fontWeight: "bold"
                  }}>
                  ₹ {Math.abs(dayBookData.totals.closingBalance).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                  {dayBookData.totals.closingBalance >= 0 ? ' Dr' : ' Cr'}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Summary Statistics */}
        <table style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: "10px",
          fontSize: "11px",
          color: "#000",
          border: "1px solid #000",
        }}>
          <tbody>
            <tr>
              <td style={{
                border: "1px solid #000",
                padding: "3px",
                fontWeight: "bold",
                background: "#f9f9f9",
                textAlign: "center"
              }}>
                Summary Statistics
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "3px" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <span>Total Sales:</span>
                  <span>₹ {dayBookData.transactions.filter(t => t.type === 'sale').reduce((sum, t) => sum + t.credit, 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <span>Total Purchases:</span>
                  <span>₹ {dayBookData.transactions.filter(t => t.type === 'purchase').reduce((sum, t) => sum + t.debit, 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <span>Total Receipts:</span>
                  <span>₹ {dayBookData.transactions.filter(t => t.type === 'receipt').reduce((sum, t) => sum + t.debit, 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <span>Total Expenses:</span>
                  <span>₹ {dayBookData.transactions.filter(t => t.type === 'expense').reduce((sum, t) => sum + t.debit, 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", borderTop: "1px solid #ccc", paddingTop: "2px", marginTop: "2px" }}>
                  <span>Net Movement:</span>
                  <span style={{ color: dayBookData.totals.totalCredit - dayBookData.totals.totalDebit >= 0 ? "#28a745" : "#dc3545" }}>
                    ₹ {Math.abs(dayBookData.totals.totalCredit - dayBookData.totals.totalDebit).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                    {dayBookData.totals.totalCredit - dayBookData.totals.totalDebit >= 0 ? ' (Income)' : ' (Expense)'}
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        {/* Footer Section */}
        <table style={{
          width: "100%",
          borderCollapse: "collapse",
          color: "#000",
          fontSize: "12px",
          border: "1px solid #000",
          marginTop: "10px"
        }}>
          <tbody>
            <tr style={{ color: "#000" }}>
              <td style={{
                width: "50%",
                verticalAlign: "top",
                textAlign: "left",
                borderRight: "1px solid #000",
                padding: "8px",
                color: "#000",
              }}>
                <strong>Remarks:</strong>
                <br />
                • All transactions are recorded as per company policy.
                <br />
                • Verified and approved by management.
                <br />
                • This is a system generated report.
                <br />
                <br />
                <strong>E.&.O.E.</strong>
              </td>
              <td style={{
                width: "25%",
                textAlign: "center",
                verticalAlign: "top",
                borderRight: "1px solid #000",
                padding: "8px",
                color: "#000",
              }}>
                <strong>Prepared By</strong>
                <br /><br /><br />
                <br />
                <div>_________________________</div>
                <div>Accountant</div>
                <small>Date: {new Date().toLocaleDateString('en-IN')}</small>
              </td>
              <td style={{
                width: "25%",
                textAlign: "center",
                verticalAlign: "top",
                padding: "8px",
                color: "#000",
              }}>
                <strong>Approved By</strong>
                <br /><br /><br />
                <br />
                <div>_________________________</div>
                <div>Manager</div>
                <small>Date: ___________</small>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <hr style={{ margin: "0px", color: "#000" }} />
      <p style={{
        width: "100%",
        textAlign: "center",
        color: "#000",
      }}>This is a Computer Generated Day Book Report</p>
    </div>
  );
};

export default DayBookPrint;